/**
 * Converts a boolean value to a 'Yes' or 'No' string.
 * @param value - The boolean value to convert.
 * @returns The 'Yes' or 'No' string, or null if the value is null or undefined.
 * @example
 * toYesNoString(true); // 'Yes'
 * toYesNoString(false); // 'No'
 * toYesNoString(null); // null
 */
export function toYesNoString(
	value: boolean | null | undefined,
): 'Yes' | 'No' | null {
	return value === true ? 'Yes' : value === false ? 'No' : null;
}
